import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const TeamContext = createContext(null);

export function useTeam() {
    return useContext(TeamContext);
}

export function TeamProvider({ children, user, userData }) {
    const [teamId, setTeamId] = useState(null);
    const [teamData, setTeamData] = useState(null);
    const [teamLoading, setTeamLoading] = useState(true);

    useEffect(() => {
        if (!user || !userData?.teamId) {
            setTeamId(null);
            setTeamData(null);
            setTeamLoading(false);
            return;
        }

        const fetchTeam = async () => {
            setTeamLoading(true);
            try {
                const teamRef = doc(db, 'teams', userData.teamId);
                const teamSnap = await getDoc(teamRef);
                if (teamSnap.exists()) {
                    setTeamId(userData.teamId);
                    setTeamData(teamSnap.data());
                } else {
                    setTeamId(null);
                    setTeamData(null);
                }
            } catch (err) {
                console.error('Team fetch error:', err);
                setTeamId(null);
                setTeamData(null);
            } finally {
                setTeamLoading(false);
            }
        };

        fetchTeam();
    }, [user, userData?.teamId]);

    const value = {
        teamId,
        teamData,
        teamLoading,
        teamRole: userData?.teamRole || 'member',
        isTeamOwner: userData?.teamRole === 'owner',
        isTeamAdmin: userData?.teamRole === 'owner' || userData?.teamRole === 'admin',
    };

    return (
        <TeamContext.Provider value={value}>
            {children}
        </TeamContext.Provider>
    );
}

export default TeamContext;
